import React, { useEffect, useState } from 'react'
import { Text, View, Image, Dimensions, TouchableOpacity } from 'react-native'
import * as Progress from 'react-native-progress'
import styles from './MyAdvanceStyles'
import theme from '../../../theme'
import { avatarPlaceholder } from '../customUtils/Constants'
import { colorFilled, colorUnfilled } from '../../../themeConstants'
import { ScrollView } from 'react-native-gesture-handler'
import { FlashList } from '@shopify/flash-list'
import { AdvanceTeamModel, AdvanceTeamRegion, MyAdvanceModel, MyAdvanceSingleModel } from './models/MyAdvanceModel'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { MyAdvanceScreen } from './MyAdvance'
import { Loader } from '../customUtils/Components/Loader'
import { fetchAuthSession } from 'aws-amplify/auth'
import { getConection } from '../appBar/context/HeaderContext'
import { request_get_advanced } from '../../services/advance.services'
import { DateFormatter } from '../customUtils/DateFormatter'

const { width } = Dimensions.get('window')

export const MyTeamScreen = ({ route }) => {
    const id = route?.params?.id
    const [myAdvance, setMyAdvance] = useState(null)
    const [updateDate, setUpdateDate] = useState('')
    const { isConnected, hasInternet } = getConection()
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        // setMyAdvance(TeamData)
        try {
            if (isConnected && hasInternet) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ''
                const data: MyAdvanceSingleModel = await request_get_advanced({ authToken, id })

                if (!data) {
                    return
                }
                if (data.my_advance) {
                    setMyAdvance(data.my_advance)
                }

                //@Fixme validar si la fecha es invalida
                let date = DateFormatter({ date: data.date })
                setUpdateDate(date)
            }
        } catch (e) {
            console.log('Error al obtener la informacion', e)
        } finally {
            setLoading(false)
        }
    }
    if (loading) {
        return <Loader />
    }
    if (!myAdvance) {
        return (
            <View>
                <View style={styles.spacer2}></View>
                <Image source={require('../../../assets/advance/noDataEvaluations.png')} style={styles.noDataEvaluations} />
                <View style={styles.spacer1}></View>
                <View style={styles.spacer1}></View>
                <Text style={styles.noDataText}>No hay información</Text>
                <View style={styles.spacer2}></View>
            </View>
        )
    }
    return <MyAdvanceScreen myAdvance={myAdvance} updateDate={updateDate} />
}
